import { useMemo } from 'react';
import { User } from '../types';

// TODO reorder a bit to have better early color options
const colorOptions = [
  'bg-indigo-800', // Cool
  'bg-fuchsia-800', // Bright/Warm
  'bg-orange-800', // Warm
  'bg-cyan-800', // Cool
  'bg-lime-800', // Warm/Green
  'bg-red-800', // Warm
  'bg-violet-800', // Neutral/Cool
  'bg-teal-800', // Cool
  'bg-yellow-800', // Warm
  'bg-emerald-800', // Cool/Green
  'bg-rose-800', // Bright
  'bg-green-800', // Neutral

  'bg-orange-900', // Warm
  'bg-indigo-900', // Cool
  'bg-lime-900', // Warm/Green
  'bg-fuchsia-900', // Bright/Warm
  'bg-cyan-900', // Cool
  'bg-red-900', // Warm
  'bg-violet-900', // Neutral/Cool
  'bg-teal-900', // Cool
  'bg-yellow-900', // Warm
  'bg-emerald-900', // Cool/Green
  'bg-rose-900', // Bright
  'bg-green-900', // Neutral

  'bg-orange-700', // Warm
  'bg-indigo-700', // Cool
  'bg-lime-700', // Warm/Green
  'bg-fuchsia-700', // Bright/Warm
  'bg-cyan-700', // Cool
  'bg-red-700', // Warm
  'bg-violet-700', // Neutral/Cool
  'bg-teal-700', // Cool
  'bg-yellow-700', // Warm
  'bg-emerald-700', // Cool/Green
  'bg-rose-700', // Bright
  'bg-green-700', // Neutral
];

export function calculateColors(users: User[]) {
  const authorColors: { [key: string]: string } = {};
  let idx = 0;
  for (const user of users) {
    if (!(user.userUuid in authorColors)) {
      authorColors[user.userUuid] = colorOptions[idx % colorOptions.length];
      idx++;
    }
  }
  return authorColors;
}

export function useColors(users: User[]) {
  const authorColors = useMemo(() => {
    return calculateColors(users);
  }, [users]);
  return authorColors;
}
